import { ROLE_METADATA } from "@thyroaid/shared";
import { Link } from "react-router";
import { useOptionalAuthClient } from "../../auth/AuthSessionProvider";
import { Button } from "../../components/Button/Button";
import { Spinner } from "../../components/Spinner/Spinner";
import { paths } from "../paths";
import { useSession } from "../session/SessionContext";
import styles from "./AppShell.module.css";

/** Header account area (WEB-007). Shows exactly what the session says — never an assumed user. */
export function SessionSummary() {
  const session = useSession();
  const auth = useOptionalAuthClient();
  switch (session.status) {
    case "loading":
      return <Spinner size="small" label="Checking session…" />;
    case "anonymous":
      return (
        <p className={styles.session}>
          <span>Not signed in</span>
          <Link to={paths.signIn} className={styles.sessionLink}>
            Sign in
          </Link>
        </p>
      );
    case "authenticated": {
      const roles = session.user.roles.map((r) => ROLE_METADATA[r].label).join(", ");
      return (
        <p className={styles.session}>
          <span className={styles.sessionName}>{session.user.displayName}</span>
          {roles && <span className={styles.sessionRoles}>{roles}</span>}
          {auth && (
            <Button variant="ghost" onClick={() => void auth.signOut()}>
              Sign out
            </Button>
          )}
        </p>
      );
    }
  }
}
